import React from "react";
import type { EngineeringWarning } from "../models/types";

interface WarningBannerProps {
  warning: EngineeringWarning;
}

const WarningBanner = ({ warning }: WarningBannerProps) => (
  <div
    className={`op-warning-banner op-warning-banner--${warning.level}`}
    role={warning.level === "error" ? "alert" : "status"}
  >
    <strong>{warning.title}</strong>
    <p>{warning.message}</p>
  </div>
);

export default WarningBanner;
